
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'
import { useSearchParams } from "react-router-dom"

export const WaterFlowPreventiveWorkExportData = (props) => {
    const { ExcelData, name, searchName, RoleID, FromDate, ToDate } = props

    const [searchParams] = useSearchParams()
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')



    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '47%' }}>

                <h5><span>&emsp;</span></h5>

                <tr>
                    <th colSpan={(DashProjectTypeId == '6' && RoleID != '16') ? 6 : 13} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Navi Mumbai Municipal Corporation</th>
                </tr>
                <tr>
                    <th colSpan={(DashProjectTypeId == '6' && RoleID != '16') ? 6 : 13} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>WATER SUPPLY DEPARTMENT</th>
                </tr>
                {
                    (DashProjectTypeId == '6' && RoleID != '16') ?
                        <tr>
                            <th colSpan={(DashProjectTypeId == '6' && RoleID != '16') ? 6 : 13} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Project Name: - {(ExcelData && ExcelData.table && ExcelData.table[0].projectName) ? (ExcelData && ExcelData.table && ExcelData.table[0].projectName) : '-'}</th>
                        </tr>
                        :
                        <tr>
                            <th colSpan={(DashProjectTypeId == '6' && RoleID != '16') ? 6 : 13} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Project Name: - Main Feeder - Morbe Dam to Digha</th>
                        </tr>
                }
                <tr>
                    <th colSpan={(DashProjectTypeId == '6' && RoleID != '16') ? 6 : 13} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Report Name: {name}</th>
                </tr>
                <tr>
                    <th colSpan={(DashProjectTypeId == '6' && RoleID != '16') ? 6 : 13} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>From Date:- {FromDate ? FromDate : '-'} -- To Date:- {ToDate ? ToDate : '-'} </th>
                </tr>
                {
                    (DashProjectTypeId == '6' && RoleID != '16') ?
                        <>
                            <thead>
                                <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                                    <th className="sr_no_col" style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                                    <th>Date</th>
                                    <th>Time</th>
                                    {
                                        (DashProjectTypeId == '6' && RoleID != '16') ?
                                            <th>Location</th>
                                            :
                                            <th>Junction</th>
                                    }
                                    <th>Pipe Size</th>
                                    <th style={{ borderRight: "1px solid black" }}>Flow Value</th>

                                </tr>
                            </thead>
                            <tbody>
                                {
                                    ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item) => {
                                        return (
                                            <tr style={{ width: "100%", border: "1px solid black" }}>
                                                <td style={{ textAlign: "left" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                <td style={{ textAlign: "left" }}>{item.readingDate ? moment(item.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                                <td style={{ textAlign: "left" }}>{item.readingTime ? item.readingTime : '-'}</td>
                                                {
                                                    (DashProjectTypeId == '6' && RoleID != '16') ?
                                                        <td>{item.locationDetails ? item.locationDetails : '-'}</td>
                                                        :
                                                        <td>{item.junctionDetails ? item.junctionDetails : '-'}</td>
                                                }
                                                <td style={{ textAlign: "left" }}>{item.pipelineDetails ? item.pipelineDetails : '-'}</td>
                                                <td style={{ textAlign: "left" }}>{item.flow ? item.flow : '0'}</td>

                                            </tr>
                                        )
                                    })
                                        :
                                        <td colSpan={15}>No data found</td>
                                }
                            </tbody>
                        </>
                        :
                        <>
                            <thead>

                                <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                                    <th rowSpan={2} className="sr_no_col" style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                                    <th rowSpan={2}>Reading Date</th>
                                    <th rowSpan={2}>Reading Time</th>

                                    {
                                        ExcelData && ExcelData.length > 0 && ExcelData.map((item) => {
                                            return (
                                                item.data_Junction.map(q => {
                                                    return (
                                                        <>
                                                            <th colSpan={q.pipeLineCount}>{q.junctionDetails}</th>
                                                        </>
                                                    )
                                                })

                                            )
                                        })
                                    }
                                </tr>

                                <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid white" }}>

                                    {
                                        ExcelData && ExcelData.length > 0 && ExcelData.map((item) => {
                                            return (
                                                item.data_Junction && item.data_Junction.map(j => {
                                                    return (
                                                        j.pipeLine.map(w => {
                                                            return (
                                                                <>
                                                                    <th >{w.pipelineDetails}</th>
                                                                </>
                                                            )
                                                        })


                                                    )
                                                })

                                            )
                                        })
                                    }
                                </tr>

                            </thead>


                            <tbody style={{ border: "1px solid black" }}>
                                {
                                    ExcelData && ExcelData.length > 0 && ExcelData.map((item, d) => {
                                        return (
                                            item.pressure && item.pressure.map((m, i) => {
                                                return (
                                                    <>
                                                        <tr style={{ width: '100%', border: "1px solid black" }}>
                                                            <td style={{ textAlign: "center" }}>{i + 1}</td>
                                                            <td style={{ textAlign: "center" }}>{m.readingDate ? moment(m.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                                            <td style={{ textAlign: "center" }}>{m.readingTime}</td>

                                                            {
                                                                m.pressure.map(n => {
                                                                    return (
                                                                        <td style={{ textAlign: "right" }}>{n.flow}</td>
                                                                    )
                                                                })
                                                            }
                                                        </tr>
                                                    </>
                                                )
                                            })
                                        )
                                    })
                                }

                            </tbody>
                        </>
                }





            </table>
        </div>
    )
}